import React, { useReducer, useEffect } from "react";
import { InputText } from "../../_components/InputText/InputText";
import styles from "../../_components/Styles/BaseStyleForAdminPanel.module.css";
import positionStyles from "./UpdatePosition.module.css";
import {PositionWithUsersAndRights, UpdatePosition} from "../../../../types/api/authorization/position.types";

interface UpdatePositionModalProps {
    position: PositionWithUsersAndRights | null;
    onClose: () => void;
    onSave: (positionData: UpdatePosition) => void;
}

export const UpdatePositionModal = ({ position, onClose, onSave }: UpdatePositionModalProps) => {
    const initialState: UpdatePosition = {
        id: "",
        name: "",
    };

    const reducer = (state: UpdatePosition, action: any) => {
        switch (action.type) {
            case "SET_FIELD":
                return { ...state, [action.name]: action.value } as UpdatePosition;
            case "SET_INITIAL":
                return { ...action.state } as UpdatePosition;
            default:
                return state;
        }
    };

    const [state, dispatch] = useReducer(reducer, initialState);

    useEffect(() => {
        if (position) {
            dispatch({
                type: "SET_INITIAL",
                state: {
                    name: position.title,
                    id: position.id
                },
            });
        }
    }, [position]);

    const handleValue = (event: any) => {
        dispatch({ type: "SET_FIELD", name: event.target.name, value: event.target.value });
    };

    const handleSubmit = (e: React.FormEvent) => {
        e.preventDefault();
        onSave(state);
        onClose();
    };

    if (!position) return null;

    return (
        <div className={styles.modalOverlay} onClick={onClose}>
            <div className={`${styles.modal} ${positionStyles.wideModal}`} onClick={(e) => e.stopPropagation()}>
                <div className={styles.modalHeader}>
                    <div className={styles.modalHeaderContent}>
                        <h2 className={styles.modalTitle}>Обновление должности</h2>
                        <p className={styles.modalSubtitle}>Измените данные и сохраните изменения</p>
                    </div>
                    <button
                        type="button"
                        className={styles.modalClose}
                        onClick={onClose}
                        aria-label="Закрыть"
                    >
                        ×
                    </button>
                </div>
                <hr className={styles.modalDivider} />

                <form onSubmit={handleSubmit}>
                    <div className={styles.modalBody}>
                        <InputText
                            name="name"
                            value={state.name}
                            handleValue={handleValue}
                            label="Название"
                            idField="name"
                            required={true}
                        />
                    </div>

                    <div className={styles.modalFooter}>
                        <button
                            type="button"
                            className={`${styles.buttonBase} ${styles.buttonSecondary}`}
                            onClick={onClose}
                        >
                            Отмена
                        </button>

                        <button
                            type="submit"
                            className={`${styles.buttonBase} ${styles.buttonPrimary}`}
                        >
                            Обновить
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default UpdatePositionModal;

